import PendingResult from './PendingResult';
export default PendingResult;
